import { render, staticRenderFns } from "./CadastroMembro.vue?vue&type=template&id=0620800e&scoped=true"
import script from "./CadastroMembro.vue?vue&type=script&lang=js"
export * from "./CadastroMembro.vue?vue&type=script&lang=js"
import style0 from "./CadastroMembro.vue?vue&type=style&index=0&id=0620800e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620800e",
  null
  
)

export default component.exports